import { lazy } from 'react'
import { PRIVATE_ROUTE, PUBLIC_ROUTE } from '@/constants'

export const publicRoutes = [
  {
    component: lazy(
      async () =>
        await import('../containers/pages/signIn').then((module) => ({
          default: module.SignInPage,
        }))
    ),
    path: PUBLIC_ROUTE.SIGN_IN,
  },
]

export const privateRoutes = [
  {
    component: lazy(
      async () =>
        await import('../containers/home').then((module) => ({
          default: module.HomeContainer,
        }))
    ),
    path: PRIVATE_ROUTE.HOME,
  },
]
